import { render, staticRenderFns } from "./clean.vue?vue&type=template&id=81136aaa"
import script from "./clean.vue?vue&type=script&lang=ts"
export * from "./clean.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports